module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressDocs),
      expression: "progressDocs"
    }],
    staticClass: "tab-content deal-documents"
  }, [_c('z-modal-sidebar', {
    ref: "sidebar",
    attrs: {
      "title": _vm.previewDocument.title
    },
    on: {
      "hide": _vm.closeDoc
    }
  }, [_c('doc', {
    attrs: {
      "document": _vm.previewDocument,
      "deal": _vm.deal,
      "removable": _vm.canRemove(_vm.previewDocument)
    },
    on: {
      "refresh-doc": function($event) {
        _vm.getDocs(true)
      }
    }
  })], 1), _vm._v(" "), (!_vm.isDealFilled) ? _c('span', [_vm._v("Создание документов доступно после заполнения заявки")]) : _vm._e(), _vm._v(" "), (_vm.isDealFilled && _vm.customersDocs && Object.values(_vm.customersDocs).length) ? _c('div', {
    staticClass: "deal-docs"
  }, _vm._l((Object.values(_vm.customersDocs)), function(customer) {
    return _c('toggle-card', {
      key: ('doc-customer-' + customer.id),
      staticClass: "deal-docs__customer",
      attrs: {
        "heading": customer.name + (customer.removed ? ' <font style=\'color: red;\'>(архив)<font>' : ''),
        "visibility": customer.visibility
      }
    }, [_c('template', {
      slot: "actions"
    }, [(_vm.isDealFilled && !_vm.hasDocs(['bill', 'invoice_a4', 'assignment', 'receipt', 'act_a4', 'stock_note']) && !_vm.$props.block) ? _c('md-menu', {
      attrs: {
        "md-direction": "bottom-start"
      }
    }, [(!customer.removed) ? _c('z-button', {
      attrs: {
        "md-menu-trigger": "",
        "square": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
        }
      }
    }, [_c('md-tooltip', {
      attrs: {
        "md-direction": "bottom",
        "md-delay": "200"
      }
    }, [_vm._v("Добавить документ")]), _vm._v(" "), _c('md-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), _c('md-menu-content', [(customer.main) ? _c('md-menu-item', {
      attrs: {
        "disabled": !!_vm.getDoc('receipt', customer.id)
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['receipt'], customer.id)
        }
      }
    }, [_vm._v("Экспедиторская расписка")]) : _vm._e(), _vm._v(" "), (customer.main) ? _c('md-menu-item', {
      attrs: {
        "disabled": !!_vm.getDoc('stock_note', customer.id)
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['stock_note'], customer.id)
        }
      }
    }, [_vm._v("Складская записка")]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "md-list-divider"
    }), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": !!_vm.getDoc('bill', customer.id)
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['bill'], customer.id)
        }
      }
    }, [_vm._v("Счёт")]), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": !_vm.deal.executor || parseInt(_vm.deal.executor.nds) !== 1 || (!!_vm.getDoc('invoice_a4', customer.id) && !!_vm.getDoc('act_a4', customer.id))
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['act_a4', 'invoice_a4'], customer.id), customer.id
        }
      }
    }, [_vm._v("Счёт фактура и акт")]), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": (!_vm.deal.executor || parseInt(_vm.deal.executor.nds) === 1 || !!_vm.getDoc('act_a4', customer.id))
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['act_a4'], customer.id)
        }
      }
    }, [_vm._v("Акт")]), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": (!_vm.deal.executor || parseInt(_vm.deal.executor.nds) === 1 || !!_vm.getDoc('act_a4', customer.id))
      },
      on: {
        "click": function($event) {
          _vm.showAgentDialog(['act_a4'], customer.id)
        }
      }
    }, [_vm._v("Акт (принципал)")]), _vm._v(" "), _c('hr', {
      staticClass: "md-list-divider"
    }), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": !_vm.deal.executor || !!_vm.getDoc('act_a4', customer.id, ['storage'])
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['act_a4'], customer.id, null, ['storage'])
        }
      }
    }, [_vm._v("Акт (хранение)")]), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": !_vm.deal.executor || !!_vm.getDoc('bill', customer.id, ['storage'])
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['bill'], customer.id, null, ['storage'])
        }
      }
    }, [_vm._v("Счёт (хранение)")]), _vm._v(" "), _c('md-menu-item', {
      attrs: {
        "disabled": !_vm.deal.executor || parseInt(_vm.deal.executor.nds) !== 1 || (!!_vm.getDoc('invoice_a4', customer.id, ['storage']) && !!_vm.getDoc('act_a4', customer.id, ['storage']))
      },
      on: {
        "click": function($event) {
          _vm.saveDocument(['act_a4', 'invoice_a4'], customer.id, null, ['storage']), customer.id
        }
      }
    }, [_vm._v("Счёт фактура и акт (хранение)")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (!customer.docs || !customer.docs.length) ? _c('div', {
      staticClass: "md-content md-theme-white"
    }, [_vm._v("Документы не созданны")]) : _vm._e(), _vm._v(" "), (customer.docs.length) ? _c('div', {
      staticClass: "md-table md-theme-white"
    }, [_c('div', {
      staticClass: "md-table-content"
    }, [_c('table', [_c('thead', [_c('tr', {
      staticClass: "md-table-row"
    }, [_c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    })])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("№")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("Документ")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("Создан")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("Последняя печать")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("Последняя отправка")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    }, [_vm._v("Принципал")])])]), _vm._v(" "), _c('th', {
      staticClass: "md-table-head"
    }, [_c('div', {
      staticClass: "md-table-head-container"
    }, [_c('div', {
      staticClass: "md-table-head-label"
    })])])])]), _vm._v(" "), _c('tbody', _vm._l((customer.docs), function(doc) {
      return _c('tr', {
        key: ('doc-customer-' + customer.id + '-' + doc.id),
        staticClass: "md-table-row",
        class: {
          'deleted': (doc.status == 'DELETED')
        }
      }, [(doc.status == 'DELETED') ? _c('md-tooltip', {
        attrs: {
          "md-direction": "bottom",
          "md-delay": "200"
        }
      }, [_vm._v("\n                                    " + _vm._s('Этот документ был удалён ' + _vm.moment(doc.updated_at).tz(_vm.$root.userTimezone).format('DD.MM.YYYY в HH:mm')) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell"
      }, [_c('div', {
        staticClass: "md-table-cell-container"
      }, [(doc.status == 'ACTUAL') ? _c('z-check', {
        staticClass: "deal-docs-select",
        attrs: {
          "name": ('doc-select-' + doc.id),
          "id": ('doc-select-' + doc.id),
          "value": doc.id
        },
        model: {
          value: (_vm.selectDocuments),
          callback: function($$v) {
            _vm.selectDocuments = $$v
          },
          expression: "selectDocuments"
        }
      }) : _vm._e()], 1)]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [(_vm.labels[doc.type]) ? _c('div', {
        staticClass: "md-table-cell-container"
      }, [_vm._v(_vm._s(_vm.getDocNumber(doc)))]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [_c('div', {
        staticClass: "md-table-cell-container",
        domProps: {
          "innerHTML": _vm._s(_vm.getDocLabel(doc))
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [(doc.created_at) ? _c('div', {
        staticClass: "md-table-cell-container"
      }, [_c('div', [_vm._v(_vm._s(_vm.moment(doc.created_at).tz(_vm.$root.userTimezone).format('DD.MM.YYYY HH:mm')))]), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "bottom",
          "md-delay": "200"
        }
      }, [_vm._v("\n                                            " + _vm._s(((doc.creater && doc.creater.login) ? (doc.creater.fio || doc.creater.login) : 'клиент')) + "\n                                        ")])], 1) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [(doc.updated_at) ? _c('div', {
        staticClass: "md-table-cell-container"
      }, [(doc.last_print_date) ? _c('div', [_vm._v("\n                                            " + _vm._s(_vm.moment(doc.last_print_date).tz(_vm.$root.userTimezone).format('DD.MM.YYYY')) + "\n                                        ")]) : _c('div', [_vm._v("--")]), _vm._v(" "), (doc.last_print_date) ? _c('md-tooltip', {
        attrs: {
          "md-direction": "bottom",
          "md-delay": "200"
        }
      }, [_vm._v("\n                                            " + _vm._s(((doc.last_printer && doc.last_printer.login) ? (doc.last_printer.fio || doc.last_printer.login) : 'клиент')) + "\n                                        ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [(doc.last_email && doc.last_email.user) ? _c('div', {
        staticClass: "md-table-cell-container"
      }, [_c('span', [_vm._v("\n                                            " + _vm._s(_vm.moment(doc.last_email.created_at).tz(_vm.$root.userTimezone).format('DD.MM.YYYY')) + ",\n                                            " + _vm._s(doc.last_email.success == '1' ? 'доставлено' : 'не доставлено') + "                                                \n                                        ")]), _vm._v(" "), _c('md-tooltip', {
        attrs: {
          "md-direction": "bottom",
          "md-delay": "200"
        }
      }, [_vm._v("\n                                            Отправлено " + _vm._s((doc.last_email.user.fio || doc.last_email.user.login)) + " (" + _vm._s(doc.last_email.user.id) + ") на " + _vm._s(doc.last_email.email) + "\n                                        ")])], 1) : _c('div', {
        staticClass: "md-table-cell-container"
      }, [_vm._v("--")])]), _vm._v(" "), _c('td', {
        staticClass: "md-table-cell",
        on: {
          "click": function($event) {
            _vm.previewDoc(doc)
          }
        }
      }, [(doc.agent && doc.agent.id) ? _c('div', {
        staticClass: "md-table-cell-container"
      }, [_vm._v("\n                                        " + _vm._s(doc.agent.name + ((doc.agent.inn) ? (', ' + doc.agent.inn) : ((doc.agent.passport_number) ? (', ' + doc.agent.passport_number) : ''))) + "\n                                    ")]) : _c('div', {
        staticClass: "md-table-cell-container"
      })])], 1)
    }))])])]) : _vm._e()], 2)
  })) : _vm._e(), _vm._v(" "), (_vm.selectDocuments.length > 0) ? _c('md-button', {
    staticClass: "md-primary md-raised md-dense mass-action",
    on: {
      "click": function($event) {
        _vm.sendDocDialog = true
      }
    }
  }, [_c('span', [_vm._v("Отправить на E-mail")]), _vm._v(" "), _c('md-icon', [_vm._v("email")])], 1) : _vm._e(), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.agentDialog
    },
    on: {
      "update:active": function($event) {
        _vm.agentDialog = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Укажите принципала")]), _vm._v(" "), [_c('div', [_vm._v("Внимание, указание принципала возможно только для исполнителя без НДС")]), _vm._v(" "), _c('div', [_vm._v("Убедитесь в корректности выбора исполнителя")]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "agent_id",
      "name": "agent_id",
      "label": "Принципал",
      "data-vv-scope": "agent",
      "data-vv-as": " ",
      "data-vv-name": "agent_id",
      "error": _vm.errors.first('agent.agent_id')
    },
    model: {
      value: (_vm.agent_id),
      callback: function($$v) {
        _vm.agent_id = $$v
      },
      expression: "agent_id"
    }
  }, _vm._l((_vm.agents), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('z-button', {
    on: {
      "click": function($event) {
        _vm.agentDialog = false
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('z-button', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.saveDocumentWithAgent()
      }
    }
  }, [_vm._v("Сохранить")])], 1)], 2), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.sendDocDialog
    },
    on: {
      "update:active": function($event) {
        _vm.sendDocDialog = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Отправка документа")]), _vm._v(" "), [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "document-recipient",
      "name": "document_recipient",
      "label": "E-mail получателя",
      "error": _vm.errors.first('document_recipient')
    },
    model: {
      value: (_vm.documentRecipient),
      callback: function($$v) {
        _vm.documentRecipient = $$v
      },
      expression: "documentRecipient"
    }
  }, [_vm._l((_vm.contacts), function(contact) {
    return _c('option', {
      key: contact.id,
      domProps: {
        "value": contact.id
      }
    }, [_vm._v("\n                    " + _vm._s(contact.email) + " " + _vm._s(contact.type_name ? '(' + contact.type_name + ')' : '') + "\n                ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Другой...")])], 2), _vm._v(" "), (_vm.documentRecipient == 'other') ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email|required'),
      expression: "'email|required'"
    }],
    attrs: {
      "label": "Ваш e-mail",
      "name": "document_recipient_other",
      "id": "document-recipient-other",
      "error": _vm.errors.first('document_recipient_other'),
      "data-vv-name": "document_recipient_other",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.documentRecipientOther),
      callback: function($$v) {
        _vm.documentRecipientOther = $$v
      },
      expression: "documentRecipientOther"
    }
  }) : _vm._e()], _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('z-button', {
    on: {
      "click": function($event) {
        _vm.sendDocDialog = false
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('z-button', {
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.sendDoc()
      }
    }
  }, [_vm._v("Отправить")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9aa87568","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Docs.vue
// module id = 1224
// module chunks = 0